import { useEffect, useState } from "react";
import axios from "axios";

import LandingPreview from "./LandingPreview";


export default function CreateLanding({ editSlug }) {
  const [editingSlug, setEditingSlug] = useState(null);
  const [editingTitle, setEditingTitle] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const [title, setTitle] = useState("");
  const [heroTitle, setHeroTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [about, setAbout] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [result, setResult] = useState("");

  const [cards, setCards] = useState([
    { icon: "fas fa-gavel", title: "Direito Penal", items: "" }
  ]);

  /* =========================
     CARREGAR LANDING (EDIÇÃO)
     ========================= */
  useEffect(() => {
    if (!editSlug) return;

    console.log("EDITANDO SLUG:", editSlug);
    carregarLanding(editSlug);
  }, [editSlug]);

  async function carregarLanding(slug) {
  try {
    const res = await axios.get(
      `https://ngs.adv.br/backend/get_landing.php?slug=${slug}`
    );

    const l = res.data;

    console.log("LANDING CARREGADA:", l);

    setEditingSlug(slug);
    setEditingTitle(l.title || "");

    // 🔹 HERO
    setTitle(l.title || "");
    setHeroTitle(l.data?.hero?.title || "");
    setSubtitle(l.data?.hero?.subtitle || "");

    // 🔹 CONTATO
    setWhatsapp(l.data?.contact?.whatsapp || "");

    // 🔹 ABOUT
    setAbout(l.data?.about?.text || "");

    // 🔹 CARDS (AQUI ESTAVA O PROBLEMA)
    if (
      l.data?.sections?.atuacaoCards &&
      Array.isArray(l.data.sections.atuacaoCards) &&
      l.data.sections.atuacaoCards.length > 0
    ) {
      setCards(
        l.data.sections.atuacaoCards.map((c) => ({
          icon: c.icon || "",
          title: c.title || "",
          items: Array.isArray(c.items) ? c.items.join("\n") : ""
        }))
      );
    } else {
      // fallback
      setCards([{ icon: "fas fa-gavel", title: "", items: "" }]);
    }

    setSuccessMsg("");
  } catch (err) {
    console.error("Erro ao carregar landing:", err);
    alert("Erro ao carregar landing para edição");
  }
}


  /* =========================
     RESET
     ========================= */
  function resetForm() {
    setEditingSlug(null);
    setEditingTitle("");

    setTitle("");
    setHeroTitle("");
    setSubtitle("");
    setWhatsapp("");
    setAbout("");

    setCards([{ icon: "fas fa-gavel", title: "Direito Penal", items: "" }]);

    setResult("");
    setSuccessMsg("");
  }

  /* =========================
     CARDS
     ========================= */
  function addCard() {
    setCards([...cards, { icon: "fas fa-scale-balanced", title: "", items: "" }]);
  }

  function removeCard(index) {
    if (cards.length === 1) {
      alert("É necessário ao menos um card.");
      return;
    }
    setCards(cards.filter((_, i) => i !== index));
  }

  function moveUp(index) {
    if (index === 0) return;
    const copy = [...cards];
    [copy[index - 1], copy[index]] = [copy[index], copy[index - 1]];
    setCards(copy);
  }

  function moveDown(index) {
    if (index === cards.length - 1) return;
    const copy = [...cards];
    [copy[index + 1], copy[index]] = [copy[index], copy[index + 1]];
    setCards(copy);
  }

  /* =========================
     SALVAR / PUBLICAR
     ========================= */
  async function publicar() {
    if (!title || !heroTitle || !whatsapp) {
      alert("Preencha ao menos Título, Hero e WhatsApp");
      return;
    }

    const payload = {
      slug: editingSlug || undefined, // ← só envia se estiver editando
      title,
      data: {
        meta: { pageTitle: title },
        hero: { title: heroTitle, subtitle },
        contact: {
          whatsapp,
          whatsappText:
            "Olá! Preciso de atendimento jurídico criminal e estou ciente de que o atendimento é particular."
        },
        texts: {
          ctaWhats: "Fale com advogada agora",
          confirmPaidText:
            "Este atendimento é PARTICULAR e sujeito a honorários profissionais."
        },
        sections: {
          atuacaoTitle: "ATUAÇÃO",
          atuacaoCards: cards.map(card => ({
            icon: card.icon,
            title: card.title,
            items: card.items
              .split("\n")
              .map(i => i.trim())
              .filter(Boolean)
          }))
        },
        about: { title: "QUEM SOMOS", text: about }
      }
    };

    try {
      const res = await axios.post(
        "https://ngs.adv.br/backend/save_landing.php",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      setSuccessMsg(
        editingSlug
          ? "Alterações salvas com sucesso."
          : "Landing criada com sucesso."
      );

      setResult(`https://ngs.adv.br/lp/${res.data.slug}`);
      setEditingSlug(res.data.slug);
    } catch (err) {
      console.error(err);
      alert("Erro ao salvar landing");
    }
  }

  /* =========================
     RENDER
     ========================= */
  return (
    <div style={pageWrapper}>

    
      {editingSlug && (
        <div style={editBox}>
          <strong>Editando:</strong> {editingTitle}
          <button style={cancelBtn} onClick={() => window.confirm("Cancelar edição?") && resetForm()}>
            Cancelar
          </button>
        </div>
      )}

      <h1 style={{ textAlign: "center" }}>
        {editingSlug ? "Editar Landing Jurídica" : "Criar Landing Jurídica"}
      </h1>

      <input style={inputStyle} placeholder="Título" value={title}
        onChange={e => setTitle(e.target.value)} />

      <input style={inputStyle} placeholder="Hero Título" value={heroTitle}
        onChange={e => setHeroTitle(e.target.value)} />

      <input style={inputStyle} placeholder="Subtítulo" value={subtitle}
        onChange={e => setSubtitle(e.target.value)} />

      <input style={inputStyle} placeholder="WhatsApp" value={whatsapp}
        onChange={e => setWhatsapp(e.target.value)} />

      <textarea style={inputStyle} rows={4} placeholder="Quem somos"
        value={about} onChange={e => setAbout(e.target.value)} />

      <h3>Cards de Atuação</h3>

      {cards.map((card, i) => (
        <div key={i} style={cardBox}>
          <div style={cardActions}>
            <strong>Card {i + 1}</strong>
            <div>
              <button onClick={() => moveUp(i)}>↑</button>
              <button onClick={() => moveDown(i)}>↓</button>
              <button onClick={() => removeCard(i)}>✕</button>
            </div>
          </div>

          <input style={inputStyle} placeholder="Ícone"
            value={card.icon}
            onChange={e => {
              const c = [...cards];
              c[i].icon = e.target.value;
              setCards(c);
            }} />

          <input style={inputStyle} placeholder="Título do Card"
            value={card.title}
            onChange={e => {
              const c = [...cards];
              c[i].title = e.target.value;
              setCards(c);
            }} />

          <textarea style={inputStyle} rows={3}
            placeholder="Itens (1 por linha)"
            value={card.items}
            onChange={e => {
              const c = [...cards];
              c[i].items = e.target.value;
              setCards(c);
            }} />
        </div>
      ))}

      <button style={addBtn} onClick={addCard}>+ Adicionar Card</button>
      <button style={buttonStyle} onClick={publicar}>
        {editingSlug ? "Salvar alterações" : "Publicar"}
      </button>

      {successMsg && <div style={successBox}>{successMsg}</div>}
      {result && <pre style={resultBox}>{result}</pre>}


       <LandingPreview slug={editingSlug} />
    

   </div>

  );
}


/* =========================
   ESTILOS
========================= */

const pageWrapper = {
  maxWidth: 820,
  margin: "40px auto 80px",
  padding: "0 20px",
  fontFamily: "'Inter', Arial, sans-serif",
  
};
const cancelBtn = {
  background: "transparent",
  border: "1px solid #d6a84f",
  color: "#7a5200",
  borderRadius: 6,
  padding: "6px 12px",
  cursor: "pointer",
  fontWeight: 600
};

const inputStyle = {
  width: "100%",
  padding: "14px 16px",
  marginBottom: 14,
  borderRadius: 10,
  border: "1px solid #ddd",
  fontSize: 14,
  outline: "none",
  transition: "border .2s, box-shadow .2s",
  boxShadow: "0 1px 2px rgba(0,0,0,.04)"
};


const buttonStyle = {
  width: "100%",
  padding: 14,
  background: "#0b0b0b",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  fontWeight: 700,
  cursor: "pointer",
  marginTop: 10
};

const addBtn = {
  width: "100%",
  padding: 12,
  background: "#444",
  color: "#fff",
  borderRadius: 8,
  border: "none",
  marginBottom: 20,
  cursor: "pointer"
};

const cardBox = {
  border: "1px solid #ddd",
  borderRadius: 8,
  padding: 12,
  marginBottom: 12,
  background: "#fafafa"
};

const cardActions = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 8,
  alignItems: "center"
};

const editBox = {
  background: "#fff7e6",
  border: "1px solid #ffe1a6",
  padding: "14px 18px",
  borderRadius: 10,
  marginBottom: 25,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: 14,
  color: "#7a5200"
};


const successBox = {
  marginTop: 15,
  padding: 12,
  background: "#e6fffa",
  borderRadius: 8,
  fontWeight: 600,
  color: "#065f46"
};

const resultBox = {
  marginTop: 10,
  background: "#f4f4f4",
  padding: 10,
  borderRadius: 6,
  fontSize: 13
};
